const initState = {
    countries: [],
    status: {
        'pending': 'En attente',
        'accepted': 'Accepté',
        'declined': 'Réfusé',
    }
};

/**
 * Redux reducer for global state; handles country data.
 * @param {Object} state - Current state
 * @param {Object} action - Dispatched action with type and data
 * @returns {Object} Updated state
 */
const Global = (state = initState, action) => {
    switch (action.type) {
        case "ADD_COUNTRIES":
            return {
                ...state,
                countries: action.data
            };
        default:
            return state;
    }
};

export default Global;
